import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, ElementRef, forwardRef } from '@angular/core';
import { Observable } from 'rxjs';
import { MatPaginator, MatSort, MatDialog, MatDialogRef } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { AddDynamicDataSetDialogComponent } from './add-dynamic-dataset-dialog.component';

import { ModuleConfiguration } from '../dynamicDataSet.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { DynamicDataSetListModel } from '../models/DynamicDataSetListModel';
import { DynamicDataSetModel } from '../models/DynamicDataSetModel';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { Subject } from 'rxjs/Subject';
import { DeleteDynamicDataSetConfirmationDialogComponent } from './delete-dynamic-dataset-confirmation-dialog.component';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { CreateDraftDynamicDataSetAction } from '../store/actions/CreateDraftDynamicAction';

@Component({
  selector: 'brd-dynamic-dataset-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => DynamicDataSetTileComponent) }],
  templateUrl: './dynamic-dataset-tile.component.html',
  styleUrls: ['./dynamic-dataset-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicDataSetTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'dataSetVersion', 'releasedDate', 'status', 'actions'];
  dataSource: StoreDataSource<DynamicDataSetListModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  editPermission: string = 'DynamicDataSetModule.DynamicDataSets:Edit';


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;

  constructor(private store: Store<TileState<DynamicDataSetListModel, DynamicDataSetModel>>,
    private router: Router,
    private dialog: MatDialog,
    elementRef: ElementRef,
    private tileContainer: TileContainer) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.refreshDataSource();
    this.loading$ = this.store.select(fromStore.getDynamicDataSetListLoading);
  }

  private refreshDataSource() {
    this.dataSource = new StoreDataSource<DynamicDataSetListModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getDynamicDataSetList),
      this.store.select(fromStore.getDynamicDataSetListTotalCount),
      this.store.select(fromStore.getDynamicDataSetListLoading),
      (p, s, search) => new actions.QueryListAction(ModuleConfiguration.moduleName,
        DynamicDataSetListModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          searchTerm: search.searchControl.value
        }),
      this.sort,
      this.search
    );
  }

  selectItem(item: DynamicDataSetListModel) {
    this.router.navigateByUrl('dynamic-dataset-workspace/' + item.key);
  }

  showAdd(): void {
    this.dialog.open(AddDynamicDataSetDialogComponent, {
      panelClass: 'customized-dialog',
      width: '648px'
    });
  }

  createDraft(element: DynamicDataSetListModel) {
    this.store.dispatch(new CreateDraftDynamicDataSetAction({ dynamicDataSetKey: element.key }));
    this.selectItem(element);
  }

  delete(element: any) {
    this.dialog.open(DeleteDynamicDataSetConfirmationDialogComponent,
      {
        panelClass: 'customized-dialog',
        data:
          {
            name: element.name,
            key: element.key
          }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/components/dynamic-dataset-tile.component.ts